import React from "react"
import img from "../assets/images/iqx-agr_logo.png"

const Footer = () => {
  return (
    <div className="Page-Footer">
      <div className="Page-Footer__Wrapper">
        <div className="Page-Footer__LinksWrapper">
          <a
            className="Page-Footer__Link"
            href="https://agr-software.com/term-and-conditions/"
          >
            Term And Conditions
          </a>
          <br />
          <a
            className="Page-Footer__Link"
            href="https://agr-software.com/privacy-policy/"
          >
            Privacy Policy
          </a>
        </div>
        <a href="https://agr-software.com" className="Page-Footer__LogoWrapper">
          <span className="Page-Footer__LogoLabel">
            Operated with{" "}
            <span aria-label="love" role="img">
              💙
            </span>{" "}
            by
          </span>
          <img
            className="Page-Footer__Logo"
            alt="Created by AGR Software"
            src={img}
          />
        </a>
      </div>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js